<div class="scroll-down">
    <div class="scroll-down__mouse">
        <span class="scroll-down__wheel"></span>
    </div>
    
    <span class="scroll-down__text">Scroll down</span>
</div>
